import { useMutation } from "@tanstack/react-query";
import apiV2 from "api-v2";
import type { TotpSetupResource } from "../types/Mfa.type";

export interface TotpReplacePayload {
	password: string;
}

/**
 * Replace a lost authenticator in one password-gated step: the backend clears the
 * existing confirmed factor + trusted devices and returns a fresh pending secret
 * (same shape as setup). Used after a recovery-code login to rebind a new device.
 */
const replaceTotp = async (payload: TotpReplacePayload): Promise<TotpSetupResource> => {
	const response = await apiV2.post("/mfa/totp/replace", payload);
	return (response.data as { data?: TotpSetupResource })?.data ?? response.data;
};

export const useTotpReplace = () =>
	useMutation<TotpSetupResource, Error, TotpReplacePayload>({
		mutationFn: replaceTotp,
	});
